<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 mb-3">
            <label>{{ $t('common_words.farm') }} *</label>
            <br />
            <el-select
              clearable
              @clear="cleanFarm()"
              @change="showCalendar()"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm farm-form"
              size="large"
              v-model="cuttingOrderForm.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>

          <div
            class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3"
            v-if="isShowCalendar"
          >
            <label>{{ $t('common_words.calendar') }} </label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-calendar shadow-sm date-form"
              size="large"
              v-model="cuttingOrderForm.calendar_sel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in calendars"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <label>{{ $t('cuttingorder.registration_date') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              @change="cleanAll()"
              :picker-options="pickerOptions"
              class="shadow-sm required-date date-form"
              v-model="cuttingOrderForm.date_sel"
              type="date"
              range-separator="-"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
            <div class="row custom-mt-30">
              <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 mb-2">
                <l-button
                  wide
                  type="info"
                  class="btn-filter"
                  @click="validate()"
                  style="width: inherit"
                >
                  {{ $t('common_words.generate') }}
                </l-button>
              </div>
            </div>
          </div>
        </div>
      </card>

      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert }}
      </div>
      <card
        class="custom-shadow-card-header custom-table-responsive"
        :title="$t('cuttingorder.cutting_order_catchs')"
        v-if="cuttingOrder"
      >
        <div class="mt-4 px-3">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead class="cusmtom-thead-color">
                  <tr class="cusmtom-thead-color">
                    <th class="text-center p-3 custom-header-label">
                      {{ $t('cuttingorder.scheduling_date') }}
                    </th>
                    <th class="text-center p-3 custom-header-label">
                      {{ $t('production.boxes') }}
                    </th>
                    <th class="text-center p-3 custom-header-label">
                      {{ $t('common_words.box_qty') }}
                    </th>
                    <th class="text-center p-3 custom-header-label">
                      {{ $t('common_words.observations') }}
                    </th>
                    <th class="text-center p-3 custom-header-label">
                      {{ $t('common_words.options') }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(_, index) in cuttingOrderForm.nCuttingOrder"
                    :key="index"
                  >
                    <!-- Start Date -->
                    <td class="text-center" style="width: 270px">
                      <el-date-picker
                        v-if="renderComponent"
                        class="shadow-sm required-start-date date-form"
                        v-model="cuttingOrderForm.start_date_sel[index]"
                        @change="validateDuplicateBoxDate(index, 'date')"
                        type="date"
                        :picker-options="getStartDatePickerOptions()"
                        :placeholder="`${$t(
                          'cuttingorder.scheduling_date'
                        )}...`"
                      />
                    </td>

                    <!-- Box -->
                    <td class="text-center" style="min-width: 280px">
                      <el-select
                        @change="validateDuplicateBoxDate(index, 'box')"
                        clearable
                        filterable
                        class="select-primary custom-width-select shadow-sm required-box"
                        size="large"
                        v-model="cuttingOrderForm.boxes_sel[index]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="option in availableBoxes"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="option.id"
                        ></el-option>
                      </el-select>
                    </td>

                    <!-- Box Qty -->
                    <td class="text-center custom-td-pd" style="width: 200px">
                      <fg-input
                        type="number"
                        min="1"
                        step="1"
                        class="m-3 text-center input-covered_area required-box-qty"
                        v-model.number="cuttingOrderForm.box_qty[index]"
                        :name="`cutting_order.box_qty${index}`"
                      />
                    </td>

                    <!-- Observation -->
                    <td class="text-center" style="min-width: 200px">
                      <el-input
                        maxlength="200"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 3 }"
                        :placeholder="$t('common_words.observation')"
                        v-model="cuttingOrderForm.observations[index]"
                      />
                    </td>

                    <!-- Opciones -->
                    <td
                      class="text-center custom-td-pd"
                      style="min-width: 100px"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <a
                          v-if="isUpdate()"
                          v-tooltip.top-center="$t('common_words.add')"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click="addRow()"
                        >
                          <em class="fa fa-plus custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="
                            cuttingOrderForm.nCuttingOrder > 1 && isDelete()
                          "
                          v-tooltip.top-center="$t('common_words.erase')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="removeRow(index)"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row mt-4" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="col-12 col-md-6 col-lg-6">
              <label class="font-weight-bold">
                {{ $t('cuttingorder.notify_users') }}
              </label>

              <select-component
                rowClass=""
                :isMultiple="true"
                :dataOptions="availableUsers"
                :requireClass="`required-notify-users`"
                :initialSelection="cuttingOrderForm.notify_users_sel"
                @onChange="handleNotifyUsersChange"
                modelName="notify_users_sel"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-6">
              <label class="font-weight-bold">
                {{ $t('cuttingorder.extra_emails') }}
              </label>

              <el-select
                v-model="cuttingOrderForm.extra_emails"
                multiple
                filterable
                allow-create
                :no-data-text="`${$t('cuttingorder.extra_emails_help')}`"
                default-first-option
                class="select-primary custom-width-select shadow-sm hide-arrow"
                :placeholder="`${$t('cuttingorder.type_email_press_enter')}`"
                @change="handleExtraEmailsChange"
              >
              </el-select>
            </div>
          </div>

          <!-- Totalizado de cajas dinámico por fecha -->
          <div class="mt-3" v-if="cuttingOrderTotalsByDate.length">
            <label class="font-weight-bold">
              {{ $t('cuttingorder.total_boxes_by_date') }}
            </label>

            <div class="table-responsive mt-2">
              <table class="table table-sm table-bordered">
                <thead class="cusmtom-thead-color">
                  <tr class="cusmtom-thead-color">
                    <th class="text-center custom-header-label">
                      {{ $t('common_words.date') }}
                    </th>
                    <th class="text-center custom-header-label">
                      {{ $t('common_words.total') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in cuttingOrderTotalsByDate" :key="row.date">
                    <td class="text-center">{{ row.date }}</td>
                    <td class="text-center font-weight-bold">
                      {{ row.total }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center font-weight-bold">
                      {{ $t('common_words.total') }}
                    </td>
                    <td class="text-center font-weight-bold">
                      {{ cuttingOrderGrandTotal }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row" v-if="!messageAlert">
            <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                @click="saveCuttingOrder()"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="deleteCuttingOrderDetails()"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinForm from 'src/mixins/forms/mixin-form';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import MixinMenu from 'src/util/mixinMenu';
import mixinLocation from 'src/util/mixinLocation';
import SweetAlert from 'src/class/Alerts';
import moment from 'moment';
import i18n from 'src/i18n';
import { isset } from 'src/util/Util.js';

export default {
  data() {
    return {
      cuttingOrderForm: {
        farm_id: null,
        calendar_sel: null,
        date_sel: new Date(moment().format('YYYY-MM-DD').replace(/-/, '/')),
        nCuttingOrder: 1,
        start_date_sel: [],
        boxes_sel: [],
        box_qty: [],
        notify_users_sel: [],
        observations: [],
        extra_emails: [],
      },
      has_details: false,
      cuttingOrder: false,
      farms: [],
      users: [],
      boxes: [],
      cutting_order_header_id: null,
      isShowCalendar: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      messageAlert: null,
    };
  },

  computed: {
    calendars() {
      if (this.cuttingOrderForm.farm_id) {
        let calendars = [];
        this.farms.forEach((element) => {
          if (element.id == this.cuttingOrderForm.farm_id) {
            calendars = element.calendars;
          }
        });
        return calendars;
      } else {
        return [];
      }
    },
    availableBoxes() {
      return this.boxes.map((box) => ({
        ...box,
        name: `${box.code} - ${box.name}`,
      }));
    },
    availableUsers() {
      return this.concatAll(
        this.users.map((u) => ({
          ...u,
          name: `${u.username} - ${u.email}`,
        }))
      );
    },

    /*
     * Calcula y retorna el total de cajas por fecha
     */
    cuttingOrderTotalsByDate() {
      const totals = {};

      const n = Number(this.cuttingOrderForm.nCuttingOrder || 0);

      for (let i = 0; i < n; i++) {
        const startDate = this.cuttingOrderForm.start_date_sel[i];
        const qty = this.cuttingOrderForm.box_qty[i];

        // Ignorar filas incompletas
        if (!isset(startDate) || !isset(qty)) continue;

        const dateKey = moment(startDate).format('YYYY-MM-DD');
        const q = Number(qty) || 0;

        if (!totals[dateKey]) totals[dateKey] = 0;
        totals[dateKey] += q;
      }

      // Convertir a array ordenado por fecha (asc)
      return Object.keys(totals)
        .sort((a, b) => a.localeCompare(b))
        .map((date) => ({
          date,
          total: totals[date],
        }));
    },

    cuttingOrderGrandTotal() {
      return (this.cuttingOrderTotalsByDate || []).reduce(
        (acc, x) => acc + (Number(x.total) || 0),
        0
      );
    },
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinNotification,
    MixinExport,
    MixinMenu,
    MixinForm,
    mixinLocation,
  ],
  watch: {
    '$i18n.locale': 'forceRerender',

    'cuttingOrderForm.date_sel'(newVal) {
      if (!isset(newVal)) return;

      const { min, max } = this.getAllowedStartDateRange();

      this.cuttingOrderForm.start_date_sel = (
        this.cuttingOrderForm.start_date_sel || []
      ).map((d) => {
        if (!isset(d)) return null;

        const md = moment(d).startOf('day');
        if (md.isBefore(min) || md.isAfter(max)) return null;

        return d;
      });
    },
  },

  methods: {
    /*
     * Esta funcion limpia los correos escritos manualmente
     */
    handleExtraEmailsChange(values) {
      // values es el array actual del el-select multiple
      const cleaned = (values || [])
        .map((e) => String(e).trim().toLowerCase())
        .filter(Boolean);

      // quitar emails duplicados
      const unique = Array.from(new Set(cleaned));

      // bloquear emails inválidos automáticamente:
      const validOnly = unique.filter((e) => this.isValidEmail(e));

      if (validOnly.length !== unique.length) {
        const invalids = unique.filter((e) => !this.isValidEmail(e));
        SweetAlert.warning(
          `${i18n.t('cuttingorder.invalid_emails_removed')}: ${invalids.join(
            ', '
          )}`
        );
      }

      this.$set(this.cuttingOrderForm, 'extra_emails', validOnly);
    },

    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
    },

    /*
     * Esta funcion valida que no se permitan duplicados de (box_id + start_date) entre filas
     */
    validateDuplicateBoxDate(index, changedField) {
      try {
        const date = this.cuttingOrderForm.start_date_sel[index];
        const boxId = this.cuttingOrderForm.boxes_sel[index];

        // Si falta caja o fecha, todavía no validamos
        if (!date || !boxId) return;

        const dateNorm = moment(date).format('YYYY-MM-DD');

        const duplicate = this.cuttingOrderForm.boxes_sel.some((sel, i) => {
          if (i === index) return false;
          if (sel !== boxId) return false;

          const otherDate = this.cuttingOrderForm.start_date_sel[i];
          if (!otherDate) return false;

          return moment(otherDate).format('YYYY-MM-DD') === dateNorm;
        });

        if (!duplicate) return;

        SweetAlert.warning(
          `${i18n.t('cuttingorder.row')} ${index + 1}: (${this.getBoxNameById(
            boxId
          )}) ${i18n.t('cuttingorder.duplicate_box_date')}`
        );

        // Limpia el campo que el usuario modificó
        if (changedField === 'box') {
          this.$set(this.cuttingOrderForm.boxes_sel, index, null);
        } else {
          this.$set(this.cuttingOrderForm.start_date_sel, index, null);
        }
      } catch (error) {
        console.error(error.message);
      }
    },

    handleNotifyUsersChange(data) {
      this.$set(this.cuttingOrderForm, data.name, data.selects);
    },

    /*
     * Esta funcion retorna el rango min y max de 2 semanas a partir de la fecha de registro
     */
    getAllowedStartDateRange() {
      const base = this.cuttingOrderForm.date_sel;

      // Si no hay fecha de registro aún, no restringimos
      if (!isset(base)) return { min: null, max: null };

      const min = moment(base).startOf('day');
      const max = moment(base).startOf('day').add(14, 'days'); // 2 semanas = 14 días

      return { min, max };
    },

    /*
     * Esta funcion activa las 2 siguientes semanas a partir de la fecha de registro
     */
    getStartDatePickerOptions() {
      const self = this;

      return {
        disabledDate(time) {
          const { min, max } = self.getAllowedStartDateRange();

          // Si aún no hay rango definido, no deshabilita nada
          if (!min || !max) return false;

          const d = moment(time).startOf('day');

          // Solo permite [min .. max] inclusive
          return d.isBefore(min) || d.isAfter(max);
        },
      };
    },

    getBoxNameById(id) {
      const box = (this.boxes || []).find((b) => b.id === id);
      return box ? `${box.code} - ${box.name}` : id;
    },

    addRow() {
      this.cuttingOrderForm.nCuttingOrder++;
      this.cuttingOrderForm.start_date_sel.push(null);
      this.cuttingOrderForm.boxes_sel.push(null);
      this.cuttingOrderForm.box_qty.push(null);
      this.cuttingOrderForm.observations.push(null);
    },

    removeRow(index) {
      if (this.cuttingOrderForm.nCuttingOrder <= 1) return;

      this.cuttingOrderForm.nCuttingOrder--;

      const fieldsToRemove = [
        'start_date_sel',
        'boxes_sel',
        'box_qty',
        'observations',
      ];

      fieldsToRemove.forEach((field) => {
        this.removeFromData(this.cuttingOrderForm, field, index);
      });
    },

    removeFromData(form, field, index) {
      try {
        if (!Array.isArray(form[field])) {
          console.warn(
            `El campo ${field} no es un array válido en el formulario.`
          );
          return;
        }
        const updatedField = form[field].filter((_, i) => i !== index);
        this.$set(form, field, updatedField);
      } catch (error) {
        console.error(`Error al actualizar ${field}: `, error);
      }
    },

    validate() {
      if (this.cuttingOrderForm.farm_id == null) {
        return this.validationInputsRequired('farm');
      } else if (this.cuttingOrderForm.date_sel == null) {
        return this.validationInputsRequired('date');
      } else if (this.cuttingOrderForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      } else {
        this.messageAlert = null;
        this.loadCuttingOrders();
        this.cleanAll();

        return true;
      }
    },

    /*
     * Esta funcion carga las ordenes de corte y cajas
     */
    loadCuttingOrders() {
      this.showHideLoading(true);
      let date = moment(this.cuttingOrderForm.date_sel).format('YYYY-MM-DD');

      Promise.all([
        Axios.getMasters(
          `cutting-orders/catchs/${date}/${this.cuttingOrderForm.farm_id}`
        ),
        Axios.getMasters('boxes/boxes'),
      ])
        .then(([cuttingOrderResponse, boxesResponse]) => {
          const cuttingOrderRes = cuttingOrderResponse.data.data;
          this.boxes = boxesResponse.data.data;

          if (
            cuttingOrderRes &&
            cuttingOrderRes.details &&
            cuttingOrderRes.details.length > 0
          ) {
            this.has_details = true;

            this.cutting_order_header_id = cuttingOrderRes.header_id;
            this.cuttingOrderForm.nCuttingOrder =
              cuttingOrderRes.details.length;

            // Se Limpian arrays antes de llenar
            this.cuttingOrderForm.start_date_sel = [];
            this.cuttingOrderForm.boxes_sel = [];
            this.cuttingOrderForm.box_qty = [];
            this.cuttingOrderForm.observations = [];

            cuttingOrderRes.details.forEach((detail) => {
              this.cuttingOrderForm.start_date_sel.push(
                moment(detail.start_date, 'YYYY-MM-DD')
              );
              this.cuttingOrderForm.boxes_sel.push(detail.box_id);
              this.cuttingOrderForm.box_qty.push(detail.box_qty);
              this.cuttingOrderForm.observations.push(detail.observation);
            });

            // Precargar usuarios notificados
            this.cuttingOrderForm.notify_users_sel = Array.isArray(
              cuttingOrderRes.notify_users
            )
              ? cuttingOrderRes.notify_users
                  .map((u) => u.user_id)
                  .filter(Boolean)
              : [];
          } else {
            this.cleanAll();
          }

          this.cuttingOrder = true;
          this.showHideLoading();
        })
        .catch((error) => {
          this.cuttingOrder = true;
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    cleanAll() {
      this.cuttingOrder = false;
      this.cutting_order_header_id = null;
      this.cuttingOrderForm.nCuttingOrder = 1;
      this.cuttingOrderForm.start_date_sel = [];
      this.cuttingOrderForm.boxes_sel = [];
      this.cuttingOrderForm.box_qty = [];
      this.cuttingOrderForm.observations = [];
      this.cuttingOrderForm.extra_emails = [];
      this.cuttingOrderForm.notify_users_sel = [];
    },

    cleanFarm() {
      this.messageAlert = null;
      this.cuttingOrderForm.farm_id = null;
      this.cuttingOrderForm.nCuttingOrder = 1;
      this.cuttingOrderForm.start_date_sel = [];
      this.cuttingOrderForm.boxes_sel = [];
      this.cuttingOrderForm.box_qty = [];
      this.cuttingOrderForm.observations = [];
      this.cuttingOrderForm.extra_emails = [];
      this.cuttingOrderForm.notify_users_sel = [];
    },

    /*
     * Esta funcion realiza las validaciones necesarias
     */
    validateCuttingOrder() {
      return new Promise((resolve, reject) => {
        this.showHideLoading(true);

        this.$validator
          .validateAll({
            farm_id: this.cuttingOrderForm.farm_id,
            date_sel: this.cuttingOrderForm.date_sel,
          })
          .then(() => {
            if (!isset(this.cuttingOrderForm.farm_id)) {
              this.validationInputsRequired('farm');

              return reject(false);
            }

            if (!isset(this.cuttingOrderForm.date_sel)) {
              this.validationInputsRequired('date');

              return reject(false);
            }

            if (!isset(this.cuttingOrderForm.boxes_sel)) {
              this.validationInputsRequired('box');

              return reject(false);
            }

            // Validación de filas (details)
            const n = Number(this.cuttingOrderForm.nCuttingOrder || 0);

            let hasAnyValidRow = false;

            for (let i = 0; i < n; i++) {
              const startDate = this.cuttingOrderForm.start_date_sel[i];
              const boxId = this.cuttingOrderForm.boxes_sel[i];
              const qty = this.cuttingOrderForm.box_qty[i];

              const isEmptyRow =
                !isset(startDate) && !isset(boxId) && !isset(qty);

              if (isEmptyRow) {
                continue; // se ignora fila vacía
              }

              hasAnyValidRow = true;

              // Si hay algo, la fila debe estar completa
              if (!isset(startDate)) {
                SweetAlert.warning(
                  `${i18n.t('common_words.date_in_row')} (${i + 1}) ${i18n.t(
                    'common_words.required'
                  )}`
                );

                return reject(false);
              }

              const { min, max } = this.getAllowedStartDateRange();
              const mStart = moment(startDate).startOf('day');

              if (min && max && (mStart.isBefore(min) || mStart.isAfter(max))) {
                SweetAlert.warning(
                  `${i18n.t('cuttingorder.scheduling_date')} (${i + 1}) ` +
                    `${i18n.t('common_words.must_be_between')} ${min.format(
                      'YYYY-MM-DD'
                    )} | ${max.format('YYYY-MM-DD')}`
                );

                return reject(false);
              }

              if (!isset(boxId)) {
                SweetAlert.warning(
                  `${i18n.t('common_words.box_in_row')} (${i + 1}) ${i18n.t(
                    'common_words.required'
                  )}`
                );

                return reject(false);
              }

              if (
                !isset(qty) ||
                Number(qty) <= 0 ||
                !Number.isInteger(Number(qty))
              ) {
                SweetAlert.warning(
                  `${i18n.t('common_words.number_boxes_row')} (${i + 1}) ${
                    i18n.t('common_words.required') || 'valor inválido'
                  }`
                );

                return reject(false);
              }
            }

            if (!hasAnyValidRow) {
              SweetAlert.warning(
                i18n.t('common_words.no_data_to_save') ||
                  'No hay filas válidas para guardar.'
              );

              return reject(false);
            }

            this.showHideLoading();
            resolve(true);
          })
          .catch(() => {
            this.showHideLoading();
            reject(false);
          });
      });
    },

    async saveCuttingOrder() {
      try {
        await this.validateCuttingOrder();
      } catch (error) {
        this.showHideLoading();
        console.warn('La validación del formulario falló.');

        return;
      }

      this.showHideLoading(true);

      const n = Number(this.cuttingOrderForm.nCuttingOrder || 0);

      const details = Array.from({ length: n })
        .map((_, index) => {
          const startDate = this.cuttingOrderForm.start_date_sel[index];
          const boxId = this.cuttingOrderForm.boxes_sel[index];
          const qty = this.cuttingOrderForm.box_qty[index];
          const observation = this.cuttingOrderForm.observations[index];

          const isEmptyRow = !isset(startDate) && !isset(boxId) && !isset(qty);
          if (isEmptyRow) return null;

          return {
            start_date: isset(startDate)
              ? moment(startDate).format('YYYY-MM-DD')
              : null,
            box_id: isset(boxId) ? boxId : null,
            box_qty: isset(qty) ? Number(qty) : 0,
            observation: isset(observation) ? observation : null,
          };
        })
        .filter((row) => row !== null);

      const data = {
        route: 'cutting-orders/catchs',

        id: this.cutting_order_header_id || null,
        farm_id: this.cuttingOrderForm.farm_id,
        date_save: moment(this.cuttingOrderForm.date_sel).format('YYYY-MM-DD'),
        notify_users: this.cuttingOrderForm.notify_users_sel,
        extra_emails: this.cuttingOrderForm.extra_emails,

        details,
      };

      const request = this.cutting_order_header_id
        ? Axios.updateMaster(data)
        : Axios.postMasters(data);

      await request
        .then((response) => {
          this.showHideLoading();
          this.cleanAll();
          SweetAlert.success(response.data.message);
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(
            error.response.data.message || 'Ocurrió un error al guardar.'
          );
        });
    },

    deleteCuttingOrderDetails() {
      if (this.has_details) {
        SweetAlert.delete(i18n.t('production.capture_details')).then(
          (result) => {
            if (result.value) {
              let data = {
                id: this.cutting_order_header_id,
                route: `cutting-orders/catchs/delete`,
              };
              Axios.destroyMaster(data)
                .then((response) => {
                  this.showHideLoading();
                  this.cleanAll();
                  this.cuttingOrder = false;
                  SweetAlert.success(response.data.message);
                })
                .catch((error) => SweetAlert.warning(error));
            }
          }
        );
      } else {
        SweetAlert.warning(i18n.t('production.no_record_to_delete'));
      }
    },

    showCalendar() {
      this.messageAlert = null;
      this.isShowCalendar = true;
      this.cuttingOrderForm.calendar_sel = null;
      this.cuttingOrder = false;

      const element = Object.values(this.farms).find(
        (el) => el.id === this.cuttingOrderForm.farm_id
      );
      if (element) {
        this.isShowCalendar = element.calendars.length > 1;
        this.cuttingOrderForm.calendar_sel =
          element.calendars.length > 1
            ? null
            : element.calendars.length == 1
            ? element.calendars[0].id
            : null;
      }

      this.isShowCalendar = false;
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('users/indexfield'),
      ])
        .then((response) => {
          const [farmsResponse, usersResponse] = response;
          this.farms = farmsResponse.data.data;
          this.users = usersResponse.data.data;

          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },

  mounted() {
    this.selectedItemOnMenu('order');
  },

  destroyed() {
    this.deselectedItemOnMenu('order');
  },
};
</script>
<style scoped>
.card .table:not(.not-last-td) thead th:last-child {
  display: revert !important;
}

.custom-td-pd {
  padding: 0px !important;
}
.custom-date-td-pd {
  padding: 15px !important;
}

.table-responsive {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-height: 65vh;
}

.cusmtom-thead-color {
  position: sticky;
  top: 0;
  z-index: 2;
}

/* Quitar la flecha para un select específico usando una clase personalizada */
::v-deep .hide-arrow .el-input__icon {
  display: none;
}
</style>
